// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--dcHHt","cards":"a10a3f92e9--cards--335wn","card":"a10a3f92e9--card--2xflt"};